import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
export class ConfirmationNotificationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }
    handelAcceptConfirmation = (okCancel) => {
        this.props.handleModal(okCancel)
    }
    render() {
        const {isDecisionModal}=this.props;
        return (
            <>
                <Modal
                    show={this.props.show}
                    onHide={this.props.handleModal}
                    backdrop="static"
                    keyboard={false}
                    className={`custom-column-modal-container ${this.props.customClass}`}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="message-body">
                            {this.props.message}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" disabled={this.props.disabled} className={`custom-btn-color`} onClick={() => this.handelAcceptConfirmation(CONFIRMATION_VALUE.Cancel)}>{isDecisionModal ? "No" : this.props.discardBtn ? "Discard" : "Cancel"}</Button>
                        <Button variant="primary" disabled={this.props.disabled} onClick={() => this.handelAcceptConfirmation(CONFIRMATION_VALUE.Ok)}>{isDecisionModal ? "Yes" : this.props.discardBtn ? "Confirm" : "Yes"}</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
